import { useTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

import backArrow from '../../assets/images/ic_arrow_forward_white_48px.svg';

const SALON_NAME_STYLE = Object.freeze({ wordWrap: 'break-word', display: 'block', maxWidth: 480 });

const Header = ({ backBtnCallBack, description, salonName = '', titleFirstPart, titleSecondPart = '', titleThirdPart = '', userName = '' }) => {
  const { t } = useTranslation();

  return (
    <header data-bem="Header--onboarding" className="header">
      {fromAnyToBool(backBtnCallBack) && (
        <span data-bem="Header__back" className="btn-back">
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <img src={backArrow} alt="back" onClick={backBtnCallBack} />
        </span>
      )}
      <span data-bem="Header__text" className="header-text">
        <h1>{t('composite.header.companyName')}</h1>
        {titleFirstPart}
        {userName && <span className="underline capitalize">{userName}</span>}
        {titleSecondPart}
        {salonName && (
          <span className="underline capitalize" style={SALON_NAME_STYLE}>
            {salonName}
          </span>
        )}
        {titleThirdPart}
        <span data-bem="Header__sub" className="header-sub">
          {description}
        </span>
      </span>
    </header>
  );
};

// this extra export is needed for tests that provide their own mock for connect()
export { Header as Header4Test };
export default Header;
